import { BrokerExtensions } from "@primaria/plugins-core";
import { BrokerDisposableHandler } from "@uxland/primary-shell";
import { AddCustomFiltersHandler } from "./handler";
import { AddCustomFiltersCommand } from "./request";

let request: BrokerDisposableHandler;

export const bootstrapAddCustomFilter = (broker: BrokerExtensions) => {
  request = broker.registerRequest(AddCustomFiltersCommand, AddCustomFiltersHandler);
};

export const teardownAddCustomFilter = () => {
  request?.dispose();
};
